<template>
  <div class="main tabs_main" style="height:89%">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">原料名称：</span>
        <el-select v-model="search.chainType" placeholder="请选择原料名称" clearable>
            <el-option
            v-for="item in optionsDicts"
            :key="item.dictId"
            :label="item.dictName"
            :value="item.dictId">
            </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <el-button   :size="size" icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dictName" label="原料名称" align="center"></el-table-column>
        <el-table-column prop="unit" label="计量单位" align="center"></el-table-column>
        <el-table-column prop="materialValue" label="实时库存" align="center" ></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">库存校正</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增供应商' : '库存校正'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="原料名称：" prop="chainType">
          <el-select v-model="ruleForm.chainType"  :size="size" placeholder="请选择原料名称" clearable  :disabled="disabled">
            <el-option
            v-for="item in optionsDicts"
            :key="item.dictId"
            :label="item.dictName"
            :value="item.dictId">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="库存重量：" prop="beforeStock">
          <el-input v-model="ruleForm.beforeStock" :size="size" clearable placeholder="请输入库存重量" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="校正重量：" prop="materialValue">
          <el-input v-model="ruleForm.materialValue" :size="size" clearable placeholder="请输入校正重量" @blur="changeAfter"></el-input>
        </el-form-item>
        <el-form-item label="校正后重量：" prop="afterStock">
          <el-input v-model="ruleForm.afterStock" :size="size" clearable placeholder="请输入校正重量" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input v-model="ruleForm.remark" :size="size" type="textarea" :rows="2" clearable placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../../pinia/index';
import { throttle, changeSize } from '../../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        id:null,//一行id
        optionsDicts:[],//原料名称
        disabled:false,//是否禁止修改
        dataList: [], //库存管理信息列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
        }, // 按钮表单
        rules: {
          chainType: [{
            required: true,
            message: '请选择原料名称',
            trigger: 'change'
          }],
          beforeStock: [{
            required: true,
            message: '请输入库存重量',
            trigger: 'blur'
          }],
          materialValue: [{
            required: true,
            message: '请输入校正重量',
            trigger: 'blur'
          }],
          afterStock: [{
            required: true,
            message: '请输入校正后重量',
            trigger: 'blur'
          }],
        },
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
    },
    methods: {
      //计算出校正后重量
      changeAfter(){
        const num1Digits = (this.ruleForm.beforeStock.toString().replace(/,/g, "").split('.')[1] || '').length;
        const num2Digits = (this.ruleForm.materialValue.toString().split('.')[1] || '').length;
        const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
        const afterValue =  (this.ruleForm.beforeStock.toString().replace(/,/g, "") * baseNum + this.ruleForm.materialValue * baseNum) / baseNum;
        this.$set(this.ruleForm,'afterStock', isNaN(afterValue) ? '' : afterValue);
      },
      //获取所有原料名称
      getDictNames(){
        let params = {
            pageNum: 1,
            pageSize: 100000000,
            dictType:'chain_type'
        }
        this.$api.Dictionary.searchDictionary(params).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsDicts = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.MaterialStock.searchMaterialStockList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 库存按钮信息
      updateProp(row) {
        this.id = row.chainInventoryRecordId
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.disabled = true
        let dictItem = this.optionsDicts.find(item => item.dictName === row.dictName);
        this.$set(this.ruleForm,'chainType', dictItem ? dictItem.dictId : row.chainType)
        this.$set(this.ruleForm,'beforeStock',row.materialValue)
      },
      // 提交库存校正按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.materialValue = this.ruleForm.materialValue*1
            params.beforeStock = (this.ruleForm.beforeStock)*1
            params.chainInventoryRecordId = this.id
            params.types = 3
            params.opType  = 1
            this.$api.MaterialStock.insertChainProjectOrUpdate(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import'@/style/layout-main.scss';
</style>